var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit24Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3238 6.34558L17.6538 5.67566C17.1561 5.1792 16.4818 4.90039 15.7788 4.90039C15.0758 4.90039 14.4015 5.1792 13.9038 5.67566L12.4488 7.13062L5.77877 13.8057C5.65702 13.9226 5.57486 14.0747 5.54377 14.2406L4.92878 17.3706C4.88653 17.5806 4.89149 17.7974 4.94333 18.0052C4.99516 18.2131 5.09255 18.4068 5.22846 18.5724C5.36437 18.738 5.53539 18.8713 5.72915 18.9626C5.92291 19.054 6.13456 19.1011 6.34877 19.1006C6.44292 19.1008 6.5368 19.0908 6.62877 19.0707L9.75877 18.4556C9.92396 18.4224 10.0754 18.3405 10.1938 18.2206L16.8638 11.5507L18.3188 10.0956C18.8159 9.59853 19.0956 8.92467 19.0965 8.22168C19.0975 7.51869 18.8196 6.84396 18.3238 6.34558ZM9.17878 16.8456L6.67878 17.3456L7.17878 14.8456L13.0638 8.96057L14.0638 9.96057L15.0638 10.9606L9.17878 16.8456ZM17.1238 8.90063L16.2638 9.76562L15.2638 8.76562L14.2638 7.76562L15.1188 6.91064C15.3028 6.7434 15.5426 6.65076 15.7913 6.65076C16.04 6.65076 16.2797 6.7434 16.4638 6.91064L17.1388 7.58557C17.3147 7.76422 17.4132 8.00491 17.4132 8.25562C17.4132 8.50632 17.3147 8.74701 17.1388 8.92566L17.1238 8.90063Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit24Line);
export default __webpack_public_path__ + "static/media/icon_edit_24_line.6d75e6c91fe40496eac07d1db6e4aac7.svg";
export { ForwardRef as ReactComponent };